import { DocsCallout, DocsCodeBlock } from "../components"

Use manual events when the application knows a business event happened and the generic tracker
should not infer it from clicks or forms.

<DocsCodeBlock language="js">
{`window.adgiroEvent("lead", {
  email: lead.email,
  phone: lead.phone,
  accountId: lead.id,
  firstName: lead.firstName,
  lastName: lead.lastName,
  transactionId: "lead_" + lead.id
})`}
</DocsCodeBlock>

Identity fields are optional, but at least one strong identifier helps provider delivery when the
visitor did not arrive with a click id. The browser tracker hashes email, phone, account id, first
name, and last name before forwarding them.

For signup or OAuth flows, fire `signup` after the user record exists:

<DocsCodeBlock language="js">
{`window.adgiroEvent("signup", {
  email: oauthProfile.email,
  accountId: user.id,
  firstName: oauthProfile.given_name,
  lastName: oauthProfile.family_name,
  transactionId: "signup_" + user.id
})`}
</DocsCodeBlock>

If the event fires on a redirect landing page, wait for the Adgiro tag before recording your own
dedupe marker. This prevents a slow async script from causing a permanent missed conversion:

<DocsCodeBlock language="js">
{`function fireAdgiroOnce(key, name, payload, attempt = 0) {
  if (sessionStorage.getItem(key) === "sent") return

  if (typeof window.adgiroEvent === "function") {
    window.adgiroEvent(name, payload)
    sessionStorage.setItem(key, "sent")
    return
  }

  if (attempt < 20) {
    window.setTimeout(() => fireAdgiroOnce(key, name, payload, attempt + 1), 250)
  }
}

fireAdgiroOnce("signup_" + user.id, "signup", {
  email: user.email,
  accountId: user.id,
  transactionId: "signup_" + user.id
})`}
</DocsCodeBlock>

Known names are normalized into Adgiro events:

- `lead`, `generate_lead`, `contact`, `quote`, and `demo_request` become `adgiro_lead`.
- `purchase`, `order`, and `checkout` become `adgiro_purchase`.
- `signup`, `sign_up`, `registration`, and `register` become `adgiro_signup`.

<DocsCallout title="Custom events">
  Unknown names are still accepted. For example, `pricing calculator used` becomes
  `adgiro_pricing_calculator_used`.
</DocsCallout>
